import { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { REGISTER_MENU_ACTIVITY } from "../store/actions/timeoutActions";

export const useMenuActivityCallback = (throttleInterval: number) => {
    // Manually throttling to reduce menu activity actions,
    // throttle from lodash don't seem to work in this context.
    const dispatch = useDispatch();
    const lastMenuActivityRef = useRef(0);
    return useCallback(() => {
        const now = new Date().getTime();
        if (now - lastMenuActivityRef.current >= throttleInterval) {
            dispatch({ type: REGISTER_MENU_ACTIVITY });
            lastMenuActivityRef.current = now;
        }
    }, [dispatch, lastMenuActivityRef, throttleInterval]);
};
